export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Sidebar.vue?vue&type=template&id=3a25209c"


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/sidebar/Sidebar.vue?vue&type=template&id=3a25209c
// module id = dluW
// module chunks = 41